import React from 'react';
import { SettingsIcon, MailIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../lib/constants';
export function Soporte() {
  return <footer className="px-4 pb-28 pt-4 text-center" data-id="element-161" data-mp="3fccdsyas9ku4">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-teal-300/25 bg-[#0b2b2e]" data-id="element-162" data-mp="3abyec4n8zj7p">
        <SettingsIcon className="h-7 w-7 text-teal-300" aria-hidden="true" data-id="element-163" data-mp="35cljoxq4x7uk" />
      </div>
      <p className="mt-3 font-display text-sm font-bold text-white" data-id="element-164" data-mp="30fleep14094i">
        Soporte
      </p>
      <a href={`mailto:${SUPPORT_EMAIL}`} className="mt-1 inline-flex items-center gap-1.5 text-[13px] font-semibold text-teal-200 underline underline-offset-2" data-id="element-165" data-mp="2vmafda2jgwn5">
        <MailIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-166" data-mp="2mo6qq4w9bjr4" />
        {SUPPORT_EMAIL}
      </a>
      <p className="mt-4 text-[11px] leading-relaxed text-teal-100/50" data-id="element-167" data-mp="2hmhhmuslhg5o">
        Profe de Fisicoquímica Resuelta · Producto digital para docentes de
        secundaria en Argentina.
      </p>
    </footer>;
}